import { useState, useRef } from 'react';

interface ChipInputProps {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
}

export function ChipInput({ value, onChange, placeholder = 'Escribe y presiona Enter...' }: ChipInputProps) {
  const [input, setInput] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const addChip = (text: string) => {
    const trimmed = text.trim();
    if (!trimmed || value.includes(trimmed)) return;
    onChange([...value, trimmed]);
    setInput('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addChip(input);
    } else if (e.key === 'Backspace' && !input && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val.endsWith(',')) {
      addChip(val.slice(0, -1));
    } else {
      setInput(val);
    }
  };

  return (
    <div
      className="min-h-[40px] w-full border border-gray-300 dark:border-gray-700 rounded-lg p-2 flex flex-wrap gap-1.5 cursor-text bg-white dark:bg-gray-800"
      onClick={() => inputRef.current?.focus()}
    >
      {value.map((chip, i) => (
        <span
          key={i}
          className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-200 text-xs rounded-full"
        >
          {chip}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onChange(value.filter((_, idx) => idx !== i)); }}
            className="text-blue-500 hover:text-blue-800 dark:hover:text-blue-100 leading-none"
          >
            ×
          </button>
        </span>
      ))}
      <input
        ref={inputRef}
        value={input}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={value.length === 0 ? placeholder : ''}
        className="flex-1 min-w-[120px] outline-none text-sm bg-transparent placeholder-gray-400 dark:placeholder-gray-500"
      />
    </div>
  );
}
